import React from "react";

function AboutCard() {
  return (
    <div className="content card">
      <p>About Me</p>
      <p style={{ lineHeight: "1.7" }}>
      Hello! I’m a full-stack web and cross-platform app developer skilled in ReactJs, Ionic, Flask, and Firebase. I’m passionate about crafting user-centric applications and excited about the possibilities of web3 technologies in transforming digital experiences.
      </p>
    </div>
  );
}

export default AboutCard;
